import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { merge, Observable, of as observableOf } from "rxjs";
import { MatPaginator } from "@angular/material/paginator";
import { catchError, map, startWith, switchMap } from "rxjs/operators";
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from "@angular/material/table";
import { MatSort, Sort, MatSortHeader } from "@angular/material/sort";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { environment } from "../../../environments/environment";
import { AbstractSellerComponent } from "../abstract/seller.component";
import { SellerAssignUtilityDialog } from "../incs/seller-assign-utility.component";
import { Pair } from "../../obj/Pair";
import { EntityBase } from "../../entity/EntityBase";
import { State } from "../../entity/State";
import { Utility } from "../../entity/Utility";
import { AuthService } from "../../service/auth.service";
import { AnalyticsService } from "../../service/analytics.service";
import { GeneralService } from "../../service/general.service";
import { User } from "../../entity/User";
import { Company } from "../../entity/Company";
import { animate, state, style, transition, trigger } from "@angular/animations";
import { HeaderComponent } from "../incs/header.component";
import { MatIcon } from "@angular/material/icon";

export interface RateclassResponse {
    name: string;
  }
@Component({
    selector: "kilowant-seller-home",
    templateUrl: "../../../html/seller/main-seller-utilities.html",
    animations: [
        trigger("detailExpand", [
            state("collapsed", style({ height: "0px", minHeight: "0" })),
            state("expanded", style({ height: "*" })),
            transition("expanded <=> collapsed", animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")),
        ]),
    ],
    imports: [HeaderComponent, MatTable, MatSort, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatSortHeader, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatPaginator]
})
export class SellerUtilitiesComponent extends AbstractSellerComponent {

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;

    dialogRef: MatDialogRef<any> = null!;

    displayedColumns: string[] = ["#","UtilityId", "State", "UtilityName","LoadZones","RateClasses","Action"];
    dataSource: MatTableDataSource<Utility>;
    expandedElement: RateclassResponse | null;
    user: User = new User();

    utilities: Utility[] = null!;

    constructor(
        router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog
    ) { super(router, route, dialog, authService, analyticsService, generalService); }

    ngOnInit(): void {
        this.reloadUser().then(u=>{
           this.dataSource = new MatTableDataSource(this.user.utilities);
           this.dataSource.paginator = this.paginator;
           this.dataSource.sort = this.sort;
           this.dataSource.sortingDataAccessor = (item, property) => {
              switch (property) {
                case "UtilityName": {
                    return item.name;
                }
                case "UtilityId": {
                    return item.id;
                }
                case "State": {
                    return (item.state==null)?"":item.state.name;
                }
                default: {
                     return "";
                }
              }
           };
        });
        this.route.params.forEach((params: Params) => {
           let action: string = params["action"];
           if (action=="add") {
              this.addUtility();
           }
       });
    }

    _loadUtilities(): void {
        this.generalService.getDetails()
            .then(u => {
               this.user = u;
               this.dataSource.data = this.user.utilities;
             });
    }


    deleteUtility(utility: Utility): void {
      this.user.utilities.splice(EntityBase.indexOf(this.user.utilities, utility),1);
      this._saveUtility();
      this._loadUtilities();
    }

    addUtility(): void {
      this.dialogRef = this.dialog.open(SellerAssignUtilityDialog, {
         disableClose: false
         ,panelClass: "card-popup"
      });
      this.dialogRef.afterClosed().subscribe(result => {
           this._loadUtilities();
           this.dialogRef = null!;
       });
    }

    private _saveUtility(): void {
       this.generalService.updateUtilities(this.user)
       .subscribe((res:any) => {
           this._loadUtilities();
       },
       (err:any) => {
          if (err.status == 400) {
          }
       });
    }
}